module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('strong', [_vm._v("TERRORISM AS CRIME")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALTERNATIVE CRIMINOLOGY SERIES")]), _c('br'), _c('em', [_vm._v("General Editor:")]), _vm._v(" Jeff Ferrell")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Pissing on Demand"), _c('br'), _vm._v("Workplace Drug Testing and the Rise of the Detox Industry")]), _c('br'), _vm._v("Ken Tunnell")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Empire of Scrounge"), _c('br'), _vm._v("Inside the Urban Underground of Dumpster Diving, Trash Picking, and"), _c('br'), _vm._v("Street Scavenging")]), _c('br'), _vm._v("Jeff Ferrell")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Prison, Inc."), _c('br'), _vm._v("A Convict Exposes Life inside a Private Prison")]), _c('br'), _vm._v("K. C. Carceral, edited by Thomas J. Bernard")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Terrorism as Crime"), _c('br'), _vm._v("From Oklahoma City to Al-Qaeda and Beyond")]), _c('br'), _vm._v("Mark S. Hamm")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8ded97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/halftitle.vue
// module id = 57
// module chunks = 0